import { render, staticRenderFns } from "./highFormwork.vue?vue&type=template&id=b2087602&scoped=true&"
import script from "./highFormwork.vue?vue&type=script&lang=js&"
export * from "./highFormwork.vue?vue&type=script&lang=js&"
import style0 from "./highFormwork.vue?vue&type=style&index=0&id=b2087602&scoped=true&lang=css&"
import style1 from "./highFormwork.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2087602",
  null
  
)

export default component.exports